import React, { useEffect, useReducer } from 'react'
import NavBarVertical from '../components/NavBarVertical'
import { Outlet, useLoaderData, Link, redirect, useNavigate } from 'react-router-dom';
import { get_tree_history_sentence } from '../api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { is_authenticated, auth_delete } from '../module/auth.js';
import { Row, Col, Button } from 'react-bootstrap'

export const loader = async () => {

    try{

      if(!is_authenticated()){
        return redirect("/login");
      }

      const response = await get_tree_history_sentence();
      return { data:response,error:null };
    }
    catch(error){ 

        if(error.status === 401){
          auth_delete();
          return redirect("/login");
        }
        return { data:null,error:error };
    }

}

function HistoryResolveJudgments() {

    const response = useLoaderData();
    const navigate = useNavigate()

    const treeReducer = (state, action) => {
      switch (action.type) {
        case 'TOGGLE_OPEN': {
          // Clone the state
          let newState = [...state];
    
          // Find the item with the matching id
          let item = newState.find(item => item.id === action.id);
    
          // If a tribunalId was provided, find the tribunal with the matching id
          if (action.tribunalId !== null) {
            let tribunal = item.children.find(tribunal => tribunal.id === action.tribunalId);
    
            // If a yearId was provided, find the year with the matching id
            if (action.yearId !== null) {
              let year = tribunal.children.find(year => year.id === action.yearId);
    
              // Toggle the open state of the year
              year.open = !year.open;
            } else {
              // Toggle the open state of the tribunal
              tribunal.open = !tribunal.open;
            }
          } else {
            // Toggle the open state of the item
            item.open = !item.open;
          }
    
          return newState;
        }
        case "SET_TREE":{
          return action.tree;
        }
        default:
          return state;
      }
    };


    const [tree,dispatch] = useReducer(treeReducer, []);

    useEffect(()=>{

      if(response !== undefined){
        if(response.error === null){ 
          dispatch({ type: 'SET_TREE', tree: response.data });
        }
      }
        
    // eslint-disable-next-line
    },[response]);

  return (
    

    <NavBarVertical expand={"sm"} title_menu={""}>
        <NavBarVertical.Menu>
          <div style={{ overflow: "auto",maxHeight: "75vh"}}>

            <p className='text-center m-0 p-2'>Materias</p>
            <ul className='p-0'>
              {
                tree.map((item,index)=>(<li key={index} style={{listStyle:"none"}} className='p-2 ps-3'> 

                  <a className='link-app' style={{position:"relative"}} data-bs-toggle="collapse" href={`#matter_${index}`} role="button" aria-expanded="false" aria-controls={`matter_${index}`} >
                   
                    <p className='m-0 ps-3' style={{fontSize:"12px"}}>
                      {item.title}
                    </p>
                  </a>
                  
                  <div className="collapse" id={`matter_${index}`}>
                    <ul className='ps-1' style={{borderLeft: "0.5px solid #c18f55",borderBottom: "0.5px solid #c18f55"}}>
                      {
                        item.children.map(tribunal => (<li key={`${item.id}${tribunal.id}`} style={{listStyle:"none"}} className='p-2 ps-3'>
                          <a className='link-app' style={{position:"relative",}} data-bs-toggle="collapse" href={`#trbunal_${item.id}${tribunal.id}`} role="button" aria-expanded="false" aria-controls={`trbunal_${item.id}${tribunal.id}`}>
                            
                            <p className='m-0' style={{width:"100%",fontSize:"12px"}}>
                              {tribunal.title}
                            </p>
                          </a>

                          <div className="collapse" id={`trbunal_${item.id}${tribunal.id}`}>

                            <ul className='ps-1' style={{borderLeft: "0.5px solid #c18f55",borderBottom: "0.5px solid #c18f55"}}>

                              {
                                tribunal.children.map(year => (<li key={`${item.id}${tribunal.id}${year.id}`} style={{listStyle:"none"}} className='p-2 ps-3'>
                                  <a className='link-app' style={{position:"relative"}} data-bs-toggle="collapse" href={`#year_${item.id}${tribunal.id}${year.id}`} role="button" aria-expanded="false" aria-controls={`year_${item.id}${tribunal.id}${year.id}`} >
                                   
                                    <p className='m-0 ps-3' style={{fontSize:"12px"}}>
                                      {year.title}
                                    </p>
                                  </a>

                                  <div className="collapse" id={`year_${item.id}${tribunal.id}${year.id}`}>

                                    <ul className='ps-1' style={{borderLeft: "0.5px solid #c18f55",borderBottom: "0.5px solid #c18f55"}}>
                                      {
                                        year.children.map(sentence => (<li key={sentence.id} style={{listStyle:"none",width:"100%",fontSize:"12px"}} className='ps-2'>
                                          <Link to={`/history_of_resolved_judgments/${sentence.id}`} style={{textDecoration:"none"}}>
                                            <FontAwesomeIcon icon={faFilePdf} style={{color:"#c93c3c"}} /> {sentence.title}
                                          </Link>
                                        </li>))
                                      }
                                    </ul>
                                  </div>
                                </li>))
                              }
                            </ul>
                          </div>
                        </li> ))
                      }
                    </ul>
                  </div>
                </li>))
              }
            </ul>

            

          </div>

          <Row className='justify-content-center mt-2'>
                <Col>
                    <Button variant="outline-secondary" className='d-table ms-auto me-auto' onClick={()=>navigate("/")}>
                        <FontAwesomeIcon icon= { faArrowLeft }/>  Home
                    </Button>
                </Col>
                
            </Row>
          
        </NavBarVertical.Menu>
        <NavBarVertical.Content>
          <Outlet/>
        </NavBarVertical.Content>
    </NavBarVertical>

  )
}

export default HistoryResolveJudgments